module.exports = __webpack_public_path__ + "img/gi_meteor.8f459d6a.png";